import type {
  ConnectingLineDelayByStationProperties,
  ConnectingLineDelayProperties,
  FreeTextProperties,
  SelfTrainDelayProperties,
} from '../../api/types';
import { cloneContent } from '../../utils/broadcastContents';
import { ConnectingLineDelayByStationFields } from './fields/ConnectingLineDelayByStationFields';
import { ConnectingLineDelayFields } from './fields/ConnectingLineDelayFields';
import { FreeTextFields } from './fields/FreeTextFields';
import { SelfTrainDelayFields } from './fields/SelfTrainDelayFields';
import type { ContentPropertyFieldsProps } from './types';

// ---------------------------------------------------------------------------
// カテゴリ別プロパティフィールド
// ---------------------------------------------------------------------------

export function ContentPropertyFields({
  content,
  routes,
  routeStops,
  istationsLines,
  gtfsStops,
  parentRouteId,

  parentVoiceId,
  onChange,
  onUploadAudio,
  onPreviewSsml,
}: ContentPropertyFieldsProps): React.JSX.Element {
  switch (content.category) {
    case 'self_train_delay':
      return (
        <SelfTrainDelayFields
          props={content.properties as Partial<SelfTrainDelayProperties>}
          onChange={(props) => onChange({ ...cloneContent(content), properties: props })}
        />
      );
    case 'connecting_line_delay':
      return (
        <ConnectingLineDelayFields
          props={content.properties as Partial<ConnectingLineDelayProperties>}
          routes={routes}
          routeStops={routeStops}
          istationsLines={istationsLines}
          onChange={(props) => onChange({ ...cloneContent(content), properties: props })}
        />
      );
    case 'connecting_line_delay_by_station':
      return (
        <ConnectingLineDelayByStationFields
          props={content.properties as Partial<ConnectingLineDelayByStationProperties>}
          routes={routes}
          routeStops={routeStops}
          istationsLines={istationsLines}
          parentRouteId={parentRouteId}
          onChange={(props) => onChange({ ...cloneContent(content), properties: props })}
        />
      );

    case 'free_text':
      return (
        <FreeTextFields
          props={content.properties as Partial<FreeTextProperties>}
          routes={routes}
          routeStops={routeStops}
          // 放送条件「終着番線」の駅 / 番線ドロップダウン用。
          // gtfsStops は route_id で絞れないため親ページが 1 回取得した全件を、
          // parentRouteId は終着駅候補を自路線に絞り込むために渡す。
          gtfsStops={gtfsStops}
          parentRouteId={parentRouteId}
          parentVoiceId={parentVoiceId}
          // 要件 2: プレビュー音声にも同じ再生速度倍率を適用するため、コンテンツの
          // playback_rate をそのまま子コンポーネントに渡す (子側で <audio> の
          // playbackRate に反映する)。
          playbackRate={content.playback_rate}
          onUploadAudio={onUploadAudio}
          onPreviewSsml={onPreviewSsml}
          onChange={(props) => onChange({ ...cloneContent(content), properties: props })}
        />
      );

    default:
      return (
        <div className="error-message">
          未対応のカテゴリ: {(content as { category: string }).category}
        </div>
      );
  }
}
